import { Vue, Component, Prop } from "vue-property-decorator";
import DZMainService from "@/service";
import DzTabs from "@/components/dzTabs";
import DzMenu from "@/components/dzMenu";
import eventBus from "@/util/eventBus";
import ExecutiveDetails from "@/components/executiveDetails";
import InitJSSDK from "@/util/initJSSDK";
import { AppUrls } from "@/util/consts";
import TaskFilter from "@/components/taskFilter/filter.vue";
import { formatMoney, mobileNumberChange } from "@/util/format";

@Component({
  components: { DzTabs, DzMenu, ExecutiveDetails, TaskFilter },
})
export default class TaskAfterSale extends Vue {
  // 获取沟通配置
  get saleAfterStatusList(): any[] {
    if (this.lastSaleRegion) {
      return [
        {
          value: 0,
          communicatesResultName: "待回访",
        },
        {
          value: 1,
          communicatesResultName: "已回访",
        },
      ];
    } else {
      return [
        {
          value: 0,
          communicatesResultName: "待回访",
        },
        {
          value: 1,
          communicatesResultName: "已回访",
        },
        {
          value: -1,
          communicatesResultName: "不再回访",
        },
      ];
    }
  }
  @Prop({ default: "" })
  taskId: string;
  @Prop({ default: "" })
  selectedGuiderId: string;
  @Prop({ default: false })
  isAllGuider: boolean;
  filterSearchFlag: boolean = false;
  public searchWidth: string = "0";
  public searchFlag: boolean = false;
  public isFilterShow: boolean = false;

  public isMainMenuWrapperShow: boolean = false;
  public popMaskFlag: boolean = false; // 任务弹框

  public popMask6Flag: boolean = false; // 任务概述弹框

  public maskPopFlag: boolean = false; // 跟进中和不跟进tab中的状态选择
  public maskPopText: string = "待回访"; // 跟进中和不跟进tab中的状态文字

  public execGuiderId: string = null; // 执行导购（仅全部导购均可执行时有效）
  public execGuiderList: any[] = []; // 任务参与导购列表

  // 不跟进状态中额外添加已忽略状态过滤
  public ignoredItem = {
    communicatesResult: "ignore",
    communicatesResultName: "已忽略",
  };

  public keywords: string = "";
  public taskDay: number | string = 0; // 哪一天的任务，方便于前端，用时间戳

  public customerList: any[] = [];

  public isExeced: boolean = false; // 是否沟通过

  public customerId: string = ""; // 选择的顾客ID

  public taskRecordId: string = ""; // 选择的taskRecordId

  public taskDetail: T2INFO = null;

  public chekedCustomer: customerItem = null;

  public guiderId: string = "";
  public siteCode: string = "";

  public taskResult: string = "";
  public saleAfterTabText: string = "";
  /**
   * 列表当前tab的索引值
   * @type {number}
   */
  public curTabIndex = 4;

  // public selfName:string = '';

  public siteName: string = "";
  public guiderPost: string = "";

  // 是否展示详情的标记
  public ExecutiveDetailsFlag: boolean = false;

  public listItem: any = {};

  public tabs: { label: string; value: number }[] = [];
  public page = 1;
  public pageSize = 30;
  public count = 0; // 总数量
  public isScroll: boolean = true; // 是否还能滚动
  public isSearchedListLoadMore: boolean = true;
  public listLoading: boolean = false;
  public isSearchedListEnd: boolean = false;
  public getSaleAfterStatusText = [
    { text: "不再回访", color: "#999999" },
    { text: "待回访", color: "#FFB900" },
    { text: "已回访", color: "#21C38C" },
  ];
  public communInfo: any = {
    communicatesResults: [],
  };

  // 任务类型
  public taskTypeCode: string = "";

  public TASK_TYPE_TO_KEY = {
    MemberNCV2: "regTimeFormat", // 入会未消费会员沟通
    AwakeSleepV2: "lastSaleDay", // 沉默会员唤醒
  };
  public TASK_TYPE_TO_TEXT = {
    MemberNCV2: "入会", // 入会未消费会员沟通
    AwakeSleepV2: "上次消费", // 沉默会员唤醒
  };
  public taskTypeToItem: string = "";

  public scrollFunction = this.debounce(this.scrollFunc, 250); // 注册事件方法

  public tabsText: string = "";

  public taskType: string = "";

  // 是否是最后一次沟通
  public lastSaleRegion: boolean = false;

  // 回访的列表
  public saleRegionList: any[] = [];
  // 选择导购的下拉框是否显示
  public selectGuiderDropdownFlag: boolean = false;
  public guiderMaskPopFlag: boolean = false;

  // 筛选的参数
  public filterParam: any = { regionStatus: 0 };
  public changeSortItem = {};
  // 是否有筛选选中的值
  public isFilterSelect: boolean = true;

  public mobileNumberChange = mobileNumberChange;

  public sortItem = [
    {
      text: "等级",
      code: "rakIndex",
      tip: "无会员等级",
      icon: "icon-biaoqian-dengji",
      color: "#F09803",
      getCode: "rakName",
      sort: "desc",
      active: true,
    },
    {
      text: "积分",
      sort: "",
      icon: "icon-biaoqian-jifen",
      color: "#FFB900",
      code: "pntVal",
      tip: "0",
      getCode: "pntVal",
      active: false,
    },
    {
      text: "消费",
      sort: "",
      tip: "近一年未消费",
      icon: "icon-biaoqian-xiaofei",
      getCode: "totalNumsFor365Days",
      color: "#ED513F",
      code: "totalNumsFor365Days",
      active: false,
    },
  ];
  public searchShow: boolean = false;

  // 排序选中项
  public changeSortItemValue = this.sortItem[0];

  public copySortItem = JSON.parse(JSON.stringify(this.sortItem));
  openSearchElement() {
    this.searchWidth = "94%";
    this.lastSaleRegion = false;
    this.searchFlag = true;
    this.searchShow = true;
    this.isFilterSelect = false;
    this.filterSearchFlag = true;
    this.keywords = "";
    this.clearSort();
    this.clearBoth();
    this.clearFilter();
  }
  closeSearchElement() {
    this.searchWidth = "0";
    this.curTabIndex = 1;
    this.lastSaleRegion = false;
    this.searchFlag = false;
    this.searchShow = false;
    this.isFilterSelect = true;
    this.keywords = "";
    this.filterSearchFlag = false;
    this.clearFilter();
    this.clearSort();
    this.clearBoth();
    this.filterParam = { regionStatus: 0 };
    this.getCommunicateInfo();
  }
  searchHandle() {
    this.clearSort();
    this.clearBoth();
    (this.$el.querySelector(".search-input") as any).blur();
    this.getCommunicateInfo().then(() => {
      this.searchFlag = false;
    });
  }

  mounted() {
    this.execGuiderId = this.selectedGuiderId;
    this.taskRecordId = "";
    this.customerId = "";
    this.taskDetail = null;
    this.page = 1;

    // 获取所需信息
    this.guiderPost = window.localStorage.getItem("siteRole");
    this.siteCode = window.localStorage.getItem("siteCode");
    this.guiderId = window.localStorage.getItem("guiderId");

    if (+this.guiderPost === 102) {
      this.execGuiderId = this.guiderId;
    }

    setTimeout(() => {
      this.clearData();
      this.communicateConfig();
      this.getSaleRegionList().then(() => {
        this.getCommunicateInfo().then(() => {
          this.taskDayInfo();
        });
      });

      // 监听切换导购事件
      eventBus.on("selectedGuiderId", (guiderId) => {
        this.execGuiderId = guiderId;
        this.page = 1;
        this.getCommunicateInfo();
        this.getSaleRegionList("listChange");
      });
    }, 200);

    // 绑定监听
    this.$el.querySelector(".con-list").addEventListener("scroll", this.scrollFunction);
  }

  // 获取售后回访
  getSaleRegionList(listChange?) {
    const param = {
      siteCode: this.siteCode,
      guiderId: this.guiderId,
      taskId: this.taskId,
      execGuiderId: this.execGuiderId,
      requestType: 2,
    };
    return DZMainService.taskAfterSaleList(param).then((res) => {
      if (res && res.content && res.content.list && res.content.list.length) {
        if (listChange !== "listChange") {
          this.curTabIndex = res.content.list[0].regionId;
        }
        this.tabs = res.content.list.map((i) => {
          return {
            label: i.regionName,
            value: i.regionId,
            visitNum: i.visitNum,
          };
        });
        this.saleRegionList = res.content.list;
        if (listChange !== "listChange") {
          this.lastSaleRegion = res.content.list.length === 1;
        }
      }
    });
  }
  public clearFilter() {
    this.$nextTick(() => {
      eventBus.emit("clearFilterData", true);
      this.isFilterShow = false;
    });
    this.isFilterSelect = false;
    this.filterParam = {};
  }

  public clearSort() {
    const deepSortItem = JSON.parse(JSON.stringify(this.copySortItem));
    this.$set(this, "sortItem", deepSortItem);
    this.changeSortItemValue = this.sortItem[0];
    this.changeSortItem = {};
  }

  public selectedTagsArray(param, status) {
    this.clearBoth();
    this.filterParam = param;
    this.isFilterSelect = status;

    this.getCommunicateInfo();
  }
  public handleSortItem(item, index) {
    this.clearBoth();
    this.isFilterSelect = true;
    this.sortItem = this.sortItem.map((val, ind) => {
      if (index === ind) {
        val.active = true;
        val.sort = val.sort ? (val.sort === "asc" ? "desc" : "asc") : "asc";

        this.changeSortItemValue = val;
      } else {
        val.active = false;
        val.sort = "";
      }
      return val;
    });

    this.changeSortItem = {
      orderKey: this.changeSortItemValue.code,
      orderType: this.changeSortItemValue.sort,
    };

    this.getCommunicateInfo();
  }
  public goCostomerCenter(cstId) {
    InitJSSDK.Init("redirectTo", () => {
      (window as any).wx.miniProgram.navigateTo({
        url: AppUrls.customerCenterV2 + `?cstId=${cstId}&external=ext`,
      });
    });
  }
  public showDetail(item) {
    this.saleAfterTabText = item.currentRegion;
    this.listItem = item;
    this.ExecutiveDetailsFlag = true;
  }

  // 监听滚动条事件
  public scrollFunc(e) {
    const scrollDiv = this.$el.querySelector(".con-list");
    const clientHeight = scrollDiv.clientHeight;
    const scrollTop = scrollDiv.scrollTop;
    const scrollHeight = scrollDiv.scrollHeight;
    console.log(scrollTop + clientHeight + 100 > scrollHeight);
    if (scrollTop + clientHeight + 100 > scrollHeight && this.isScroll) {
      console.log("到底部了！");
      this.isScroll = false;
      this.getCommunicateInfo(true);
    }
  }

  // 防抖动函数
  public debounce(cb, waitTime, immediate?) {
    let timeout;
    return function() {
      const args = arguments;
      const later = () => {
        timeout = null;
        if (!immediate) {
          cb.apply(this, args);
        }
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, waitTime);
      if (callNow) {
        cb.apply(this, args);
      }
    };
  }
  /*清除数据*/
  public clearData() {
    this.page = 1;
    this.isScroll = true;
    this.isSearchedListEnd = false;
    this.customerList = [];
    this.count = 0;
    this.listItem = {};
    this.selectGuiderDropdownFlag = false;
  }
  /**
   * 任务执行人列表
   */
  public getCommunicateInfo(formScroll?: boolean) {
    this.listLoading = true;
    // 修复滚动条到底部后显示加载中
    if (formScroll) {
      setTimeout(() => {
        const scrollDiv = this.$el.querySelector(".con-list");
        const clientHeight = scrollDiv.clientHeight;
        const scrollHeight = scrollDiv.scrollHeight;
        console.log(scrollDiv.scrollTop, scrollHeight - clientHeight - 1);
        scrollDiv.scrollTop = scrollHeight - clientHeight - 1;
      });
    }

    const postParams = {
      ...{
        taskId: this.taskId, // 任务ID
        regionId: this.searchShow ? 0 : this.curTabIndex,
        searchDay: +this.taskDay,
        page: this.page,
        regionStatus: this.taskResult ? this.taskResult : 9,
        pageSize: this.pageSize,
        execGuiderId: this.execGuiderId,
        customerFlag: this.searchShow ? "0" : this.curTabIndex,
        taskResult: this.taskResult,
        keywords: this.keywords,
        requestType: 2,
      },
      ...this.changeSortItem,
      ...this.filterParam,
    };

    return DZMainService.afterSaleCustomerList(postParams)
      .then((res) => {
        if (res.code === 20000 && res.content) {
          if (res.content.list.length === 0 && this.page !== 1) {
            this.isSearchedListEnd = true;
            this.isScroll = false;
          } else {
            // 修复连续切换tab时，加载数据出错问题
            if (this.page === 1 || postParams.page === 1) {
              this.page = 1;
              this.$set(
                this,
                "customerList",
                res.content.list
                  .filter((i) => {
                    return i.cstId;
                  })
                  .map((i) => {
                    i.pntVal = formatMoney(i.pntVal);
                    return i;
                  }),
              );
            } else {
              this.customerList = this.customerList
                .concat(res.content.list)
                .filter((i) => {
                  return i.cstId;
                })
                .map((i) => {
                  i.pntVal = formatMoney(i.pntVal);
                  return i;
                });
            }
            this.isScroll = true;
            this.count = res.content.count;
            this.page++;
          }
        }
      })
      .finally(() => (this.listLoading = false));
  }

  /**
   * 任务执行详情
   */
  public taskDayInfo() {
    DZMainService.getTaskInfo({
      taskId: this.taskId,
      searchDay: this.taskDay,
    }).then((resp) => {
      this.taskDetail = resp.content;
      this.taskType = this.taskDetail.taskTypeCode;
      if (this.taskDetail.chooseGuiderType === "AllGuider") {
        this.getExecGuiderList();
      } else {
        this.$nextTick(() => {
          eventBus.emit("taskLoadSuccess", true);
        });
      }
      this.taskTypeCode = this.taskDetail.taskTypeCode;
      // 判断是否显示任务专有的字段
      this.taskTypeToItem = this.TASK_TYPE_TO_KEY[this.taskTypeCode];
      // //获取指定时间任务列表
      DZMainService.taskDayInfo({
        taskId: this.taskId,
        searchDay: +this.taskDay,
      })
        .then((res: any) => {
          this.popMask6Flag = res.content.isFirstVisit === 1; // 导购首次进入该任务时默认展示任务概述，非首次进入不展示
        })
        .catch((e) => {
          // console.log("taskDayInfo=>", e);
        });
    });
  }

  // 获取沟通配置
  public communicateConfig() {
    return DZMainService.getCommunicateConfig({
      taskId: this.taskId,
    }).then((res) => {
      this.communInfo = { ...res.content };
    });
  }

  public getCommunicatesStatusList(val, item) {
    // 重置状态
    this.taskResult = undefined;
    this.maskPopText = "待回访";

    this.taskResult = item.value;
    this.maskPopText = item.communicatesResultName;
    this.page = 1;
    this.maskPopFlag = false;
    this.customerList = [];
    this.getSaleRegionList("listChange").then(() => {
      this.getCommunicateInfo();
    });
  }

  // 任务导购类型是所有导购均可执行时，获取任务参与导购列表
  public getExecGuiderList() {
    DZMainService.taskReportExecGuiderList({
      siteCode: this.siteCode,
      guiderId: this.guiderId,
      taskId: this.taskId,
    }).then((res) => {
      this.execGuiderList = res.content.list || [];
      this.$nextTick(() => {
        eventBus.emit("taskLoadSuccess", true);
      });
    });
  }
  // 全部导购下拉框选择事件
  public getCommunicatesListByGuider(val, item) {
    this.execGuiderId = item.guiderId;

    this.guiderMaskPopFlag = false;
    this.page = 1;
    this.customerList = [];
    this.getCommunicateInfo();
  }
  public closePopMask() {
    this.popMaskFlag = false;
    this.taskRecordId = "";
    this.customerId = "";
  }

  public closePopMask6() {
    this.popMask6Flag = false;
  }
  public changePopMask() {
    this.popMask6Flag = !this.popMask6Flag;
  }

  /**
   * 沟通详情列表切换
   * @param {number} index
   */
  public onCommunicateInfoListSwitch(index: number): void {
    this.curTabIndex = index;

    this.clearFilter();
    this.clearSort();
    this.isFilterSelect = true;

    this.lastSaleRegion = this.tabs.length === index;

    if (index === 6) {
      this.communInfo.communicatesResults.push(this.ignoredItem);
    } else {
      this.communInfo.communicatesResults = this.communInfo.communicatesResults.filter(
        (i) => i.communicatesResult !== "ignore",
      );
    }

    this.clearFilter();
    this.clearSort();
    this.clearBoth();
    this.filterParam = { regionStatus: 0 };
    this.isFilterSelect = true;
    this.getCommunicateInfo();
  }

  public clearBoth() {
    this.page = 1;
    this.customerList = [];
    this.isScroll = true;
    this.taskResult = "";
    this.count = 0;
  }
  /**
   * 主菜单隐藏
   * @return null
   */
  public onHideMainMenu(): void {
    setTimeout(() => {
      this.isMainMenuWrapperShow = false;
    }, 0);
  }
}
